import { InputLabel, TextField, Typography } from '@mui/material';
import { useMask } from '@react-input/mask';

import { DateTextInputElement } from '@/components/DynamicForm/types/DynamicFormTypes';

const formatDateMDY = (entry = '') =>
	entry.length < 11 && entry.split('-').length === 3
		? new Date(`${entry}T00:00:00`).toLocaleDateString('en-US', {
				day: '2-digit',
				month: '2-digit',
				year: 'numeric',
		  })
		: entry;

export default function DateTextInput({
	label,
	name,
	type = 'text',
	onChange,
	onBlur,
	value,
	showError,
	errMsg,
}: DateTextInputElement) {
	const inputRef = useMask({
		mask: 'MM/DD/YYYY',
		showMask: true,
		separate: true,
		replacement: { D: /\d/, M: /\d/, Y: /\d/ },
	});

	return (
		<>
			{label && (
				<InputLabel data-test-id={`${name}-default`} htmlFor={name}>
					{label}
				</InputLabel>
			)}
			<TextField
				variant="outlined"
				type={type}
				name={name}
				id={name}
				placeholder={'MM/DD/YYYY'}
				onChange={onChange}
				onBlur={onBlur}
				value={formatDateMDY(value as string)}
				error={showError}
				helperText={<Typography variant="errorValidation">{errMsg}</Typography>}
				inputRef={inputRef}
			/>
		</>
	);
}
